import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons, componentsPlugin, IconsPlugin} from 'bootstrap-vue'

import './registerServiceWorker'
import router from './router'
import store from './store'

// import bootstrap vue
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import '@/assets/global.scss'

import {
    getAxiosInstance,
    getRouteInstance,
    getStoreInstance,
    initAxios, initI18n,
    initRouter,
    initStore
} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance";


initAxios(store, router)
let axios = getAxiosInstance()

initStore(store)
let newStore = getStoreInstance()

initRouter(router)
let newRouter = getRouteInstance()

// register bootstrap vue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)

// register vuelidate
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

Vue.config.productionTip = false

// only to define formatter language value
export const i18n = {}

initI18n(i18n)

export const dashboardLink = 'https://dash.taherdanakstore.ir';
export const siteLink = 'https://taherdanakstore.ir';

// import main requirements
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/BaseMethods'

// register miw-components
import './plugin/miw-components/indexComponents'
import App from './App.vue'


// authenticate user
newStore.dispatch('Authentication/attemptLogin').then(async () => {
    await store.dispatch('SiteInfo/getSiteInfos')
    await store.dispatch("Language/getLanguages");
    await newStore.dispatch('SiteServiceManager/isProjectExpire')

    new Vue({
        router: newRouter,
        store: newStore,
        render: h => h(App)
    }).$mount('#app')

})
